import React, { useState } from 'react';
import './FAQPage.css';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../translations/translations';

const FAQPage = () => {
  const [activeIndex, setActiveIndex] = useState(null);
  const { language } = useLanguage();
  const t = translations[language].faq;

  const toggleFAQ = (categoryIndex, questionIndex) => {
    const index = `${categoryIndex}-${questionIndex}`;
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="faq-page-container">
      <h1 className="faq-page-title">{t.title}</h1>
      <div className="faq-list">
        {t.categories.map((category, categoryIndex) => (
          <React.Fragment key={categoryIndex}>
            {category.questions.map((faq, questionIndex) => {
              const index = `${categoryIndex}-${questionIndex}`;
              return (
                <div key={index} className={`faq-item ${activeIndex === index ? 'faq-item-active' : ''}`}>
                  <div className="faq-question-container" onClick={() => toggleFAQ(categoryIndex, questionIndex)}>
                    <p className="faq-question">{faq.question}</p>
                    <span className="faq-icon">{activeIndex === index ? '-' : '+'}</span>
                  </div>
                  <div className={`faq-answer ${activeIndex === index ? 'active' : ''}`}>
                    <p>{faq.answer}</p>
                  </div>
                </div>
              );
            })}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default FAQPage;
